<template>
  <div>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>Transmitir Guia a ServiEntrega</v-card-title>
        <v-card-text>
          <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-model="empresa"
              :items="empresas"
              item-text="empresa"
              item-value="id"
              label="Empresa"
              append-icon="mdi-office-building"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-model="producto"
              :items="productos"
              item-text="nombre_producto"
              item-value="id_producto"
              label="Producto"
              append-icon="mdi-truck-check"
              return-object
              clearable
              :rules="[reglas.requeridoCbx]"
            ></v-combobox>
          </v-col>
        </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click="enviar()"> Enviar a ServiEntrega </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
      <v-dialog  :scrollable="true" v-model="dlgMensaje" width="900" transition="dialog-bottom-transition" persistent :fullscreen="false">
        <v-card>
          <v-toolbar dark dense color="#96298A" max-height="35" height="35">
              <v-toolbar-title>Resultados</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-divider vertical />
              <v-btn icon dark @click="closeMensajes()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Guía</th>
                    <th>Resultado</th>
                    <th>Guía Operador</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(msg,index) in mensajes" :key="index">
                    <td>{{ msg.guia }}</td>
                    <td>{{ msg.mensaje }}</td>
                    <td>{{ msg.guia_operador }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay">
        <waiting />
    </v-overlay>
  </div>
  </template>

  <script>
  import apicon from '../plugins/apicon';
  import Waiting from '../components/Waiting.vue';
  export default {
    props:{
      id: {
        type: Number,
        default: 0,
      },
      guias : {
        type : Array
      },
      mode:{
        type: String,
        default: 'CL'
      }
    },
    components:{
      Waiting
    },
    data(){
      return{
        valid: true,
        mensajes: [],
        dlgMensaje : false,
        empresas: [],
        empresa: null,
        overlay: false,
        productos: [
          {id_producto : 1, nombre_producto : 'Documento Unitario'},
          {id_producto : 2, nombre_producto : 'Mercancia Premier'},
          {id_producto : 3, nombre_producto : 'Documento Masivo'},
          {id_producto : 6, nombre_producto : 'Mercancia Industrial'},
          {id_producto : 8, nombre_producto : 'Valija Empresarial'},
          {id_producto : 71, nombre_producto : 'Farma'},
        ],
        producto: null
      }
    },
    methods:{
      fillEmpresas: function() {
        apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa').then((result) => {
          this.empresas = result;
        });
      },
      enviar:async function(){
        let url = 'enviarservie'
        if (this.$refs.form.validate()) {
          this.overlay = true
          await apicon.saveDataApi(apicon.getApiBaseUrl() + url,{
            guias : this.guias,
            empresa : this.empresa,
            producto : this.producto,
            mode : this.mode
          }).then((result) => {
            result.message.forEach(el => {
              this.mensajes.push({
                guia : el.guia,
                mensaje : el.resp.msj,
                guia_operador : el.resp.id,
              })
            });
            this.overlay = false
            this.dlgMensaje = true
          }).catch((err) => {
            console.log(err)
            this.overlay = false;
            this.$swal("Error al transmitir");
          })
        }
      },
      closeMensajes: function(){
        this.dlgMensaje = false;
        this.mensajes = [];
      }
    },
    mounted: function(){
      this.fillEmpresas();
    }
  }
  </script>

  <style>

  </style>
